import React from 'react';
import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CustomerServicePackageEffectiveStatus } from '../../services/servicePackageService';

const STATUS_COLORS = {
  [CustomerServicePackageEffectiveStatus.Active]: { bg: '#e8f5e9', color: '#2e7d32' },
  [CustomerServicePackageEffectiveStatus.PendingCheckout]: { bg: '#fff3e0', color: '#ef6c00' },
  [CustomerServicePackageEffectiveStatus.Exhausted]: { bg: '#eceff1', color: '#455a64' },
  [CustomerServicePackageEffectiveStatus.Expired]: { bg: '#fff3e0', color: '#e65100' },
  [CustomerServicePackageEffectiveStatus.Canceled]: { bg: '#ffebee', color: '#c62828' },
  [CustomerServicePackageEffectiveStatus.Refunded]: { bg: '#e1f5fe', color: '#0369a1' },
};

const CustomerServicePackageStatusChip = ({ effectiveStatus, sx }) => {
  const { t } = useTranslation();
  const statusColors = STATUS_COLORS[effectiveStatus] || STATUS_COLORS.Exhausted;

  return (
    <Chip
      size="small"
      label={t(`servicePackagesManagement.customer.effectiveStatus.${effectiveStatus}`, {
        defaultValue: effectiveStatus || '',
      })}
      sx={{ height: 22, fontWeight: 600, bgcolor: statusColors.bg, color: statusColors.color, ...sx }}
    />
  );
};

export default CustomerServicePackageStatusChip;
